import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useApi from "../Api";
import { VersionData } from "../types/version";

type CreateWorldDialogProps = {
  open: boolean;
  handleClose: (worldCreated: boolean) => void;
};

const CreateWorldDialog: React.FC<CreateWorldDialogProps> = ({
  open,
  handleClose,
}) => {
  const { get, post } = useApi();
  const [versions, setVersions] = useState<VersionData[]>([]);
  const [versionName, setVersionName] = useState<string | null>(null);

  useEffect(() => {
    get<{ versions: VersionData[] }>("versions").then(({ versions }) => {
      versions.sort((a, b) => (a.name < b.name ? -1 : 1));
      setVersions(versions);
    });
  }, [get]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();

            const name = (
              document.getElementById("create-world-name") as HTMLInputElement
            ).value;

            const version = versions.find(
              (version) => version.name === versionName
            );

            const { name: _, ...serverProfile } = version;

            console.log({ name, serverProfile });

            post("worlds", { name, serverProfile }).then(() =>
              handleClose(true)
            );
          },
        },
      }}
    >
      <DialogTitle>Create world</DialogTitle>
      <DialogContent>
        <DialogContentText>Create a new world</DialogContentText>
        <TextField
          autoFocus
          required
          margin="dense"
          id="create-world-name"
          name="name"
          label="Name"
          type="text"
          fullWidth
          variant="standard"
        />
        <Select
          id="create-world-version"
          name="version"
          value={versionName ?? ""}
          fullWidth
          onChange={(event) => setVersionName(event.target.value)}
        >
          {versions.map((version) => (
            <MenuItem key={version.name} value={version.name}>
              {version.name}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Cancel</Button>
        <Button type="submit">Create world</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateWorldDialog;
